namespace RioERP.Orders {
    export interface OrderBrandAmbassadorShareRow {
        Id?: number;
        OrderId?: number;
        BrandAmbassadorId?: number;
        SharePercentage?: number;
        OrderGrossAmount?: number;
        ShareAmount?: number;
        SettelmentId?: number;
        ESettelementStatus?: Web.Enums.SettelementStatusType;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        OrderTaxAmount?: number;
        OrderFreezeData?: boolean;
        OrderShippingProviderId?: number;
        BrandAmbassadorName?: string;
        BrandAmbassadorDescription?: string;
        BrandAmbassadorEmail?: string;
        BrandAmbassadorAlternateEmail?: string;
        BrandAmbassadorMobile?: string;
        BrandAmbassadorAlternateMobile?: string;
        BrandAmbassadorAddress?: string;
        BrandAmbassadorCity?: string;
        BrandAmbassadorStateId?: number;
        BrandAmbassadorUserId?: number;
        BrandAmbassadorGstin?: string;
        BrandAmbassadorPan?: string;
        BrandAmbassadorGstCertificate?: string;
        BrandAmbassadorBankName?: string;
        BrandAmbassadorBankAccountType?: number;
        BrandAmbassadorBankAccountName?: string;
        BrandAmbassadorBankAccountNo?: string;
        BrandAmbassadorBankIfscCode?: string;
        BrandAmbassadorPincode?: number;
        BrandAmbassadorIsActive?: boolean;
        BrandAmbassadorInsertUserId?: number;
        BrandAmbassadorInsertDate?: string;
        BrandAmbassadorUpdateUserId?: number;
        BrandAmbassadorUpdateDate?: string;
        BrandAmbassadorCustomerId?: number;
        BrandAmbassadorDiscountCoupon?: string;
    }

    export namespace OrderBrandAmbassadorShareRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Orders.OrderBrandAmbassadorShare';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            BrandAmbassadorId = "BrandAmbassadorId",
            SharePercentage = "SharePercentage",
            OrderGrossAmount = "OrderGrossAmount",
            ShareAmount = "ShareAmount",
            SettelmentId = "SettelmentId",
            ESettelementStatus = "ESettelementStatus",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            OrderTaxAmount = "OrderTaxAmount",
            OrderFreezeData = "OrderFreezeData",
            OrderShippingProviderId = "OrderShippingProviderId",
            BrandAmbassadorName = "BrandAmbassadorName",
            BrandAmbassadorDescription = "BrandAmbassadorDescription",
            BrandAmbassadorEmail = "BrandAmbassadorEmail",
            BrandAmbassadorAlternateEmail = "BrandAmbassadorAlternateEmail",
            BrandAmbassadorMobile = "BrandAmbassadorMobile",
            BrandAmbassadorAlternateMobile = "BrandAmbassadorAlternateMobile",
            BrandAmbassadorAddress = "BrandAmbassadorAddress",
            BrandAmbassadorCity = "BrandAmbassadorCity",
            BrandAmbassadorStateId = "BrandAmbassadorStateId",
            BrandAmbassadorUserId = "BrandAmbassadorUserId",
            BrandAmbassadorGstin = "BrandAmbassadorGstin",
            BrandAmbassadorPan = "BrandAmbassadorPan",
            BrandAmbassadorGstCertificate = "BrandAmbassadorGstCertificate",
            BrandAmbassadorBankName = "BrandAmbassadorBankName",
            BrandAmbassadorBankAccountType = "BrandAmbassadorBankAccountType",
            BrandAmbassadorBankAccountName = "BrandAmbassadorBankAccountName",
            BrandAmbassadorBankAccountNo = "BrandAmbassadorBankAccountNo",
            BrandAmbassadorBankIfscCode = "BrandAmbassadorBankIfscCode",
            BrandAmbassadorPincode = "BrandAmbassadorPincode",
            BrandAmbassadorIsActive = "BrandAmbassadorIsActive",
            BrandAmbassadorInsertUserId = "BrandAmbassadorInsertUserId",
            BrandAmbassadorInsertDate = "BrandAmbassadorInsertDate",
            BrandAmbassadorUpdateUserId = "BrandAmbassadorUpdateUserId",
            BrandAmbassadorUpdateDate = "BrandAmbassadorUpdateDate",
            BrandAmbassadorCustomerId = "BrandAmbassadorCustomerId",
            BrandAmbassadorDiscountCoupon = "BrandAmbassadorDiscountCoupon"
        }
    }
}
